export enum StatusCode {
    OK = 200,
    CREATED = 201,
    NO_CONTENT = 204,
    ERROR = 400,
    NOT_FOUND = 404,

    // Custom
    PARSE_ERROR = 666,
}